import {
  LOAD_CUSTOMER,
  LOAD_CUSTOMER_DATA,
  LOAD_CUSTOMER_DATA_FAILURE,
  CLOSE_CUSTOMERID_CHANGE_FORM_ERROR,
  CLOSE_CUSTOMERID_CHANGE_FORM_MODAL,
  OPEN_CUSTOMERID_CHANGE_FORM_MODAL,
  CLEAR_CHANGECUSTOMERID_REQUEST,
  CLEAR_CUSTOMER_REQUEST,
  GET_CUSTOMERS_REQUEST,
  GET_CUSTOMERS_SUCCESS,
  GET_CUSTOMERS_FAILURE,
  GET_CUSTOMER_DETAILS_REQUEST,
  GET_CUSTOMER_DETAILS_SUCCESS,
  GET_CUSTOMER_DETAILS_FAILURE,
  GET_CUSTOMER_DETAILS_CLEAR
} from '../actions';

/**
 * Customer reducer (some general actions)
 */
function customer(state = {
  isLoadingData: false,
  storeCustomer: null,
  isCustomerIdChangeModalShown: false,
  returnedExistingCustomerId: '',
  isGettingCustomers: false,
  customers: [],
  customersCount: 0,
  getCustomerDetailsError: null,
}, action) {
  switch (action.type) {
    case LOAD_CUSTOMER:
      return {
        ...state,
        isLoadingData: false,
        storeCustomer: action.storeCustomer
      };
    case LOAD_CUSTOMER_DATA:
      return {
        ...state,
        isLoadingData: true,
        storeCustomer: null,
        customerDataLoadError: null
      };
    case LOAD_CUSTOMER_DATA_FAILURE:
      return {
        ...state,
        isLoadingData: false,
        customerDataLoadError: action.customerDataLoadError
      };
    case CLOSE_CUSTOMERID_CHANGE_FORM_ERROR:
      return {
        ...state,
        isCustomerIdChangeModalShown: action.isCustomerIdChangeModalShown
      };
    case CLOSE_CUSTOMERID_CHANGE_FORM_MODAL:
      return {
        ...state,
        isCustomerIdChangeModalShown: action.isCustomerIdChangeModalShown,
        returnedExistingCustomerId: action.returnedExistingCustomerId
      };
    case OPEN_CUSTOMERID_CHANGE_FORM_MODAL:
      return {
        ...state,
        isCustomerIdChangeModalShown: action.isCustomerIdChangeModalShown
      };
    case CLEAR_CHANGECUSTOMERID_REQUEST:
      return {
        ...state,
        returnedExistingCustomerId: ''
      };
    case CLEAR_CUSTOMER_REQUEST:
      return {
        ...state,
        isLoadingData: false,
        storeCustomer: null
      };
    case GET_CUSTOMERS_REQUEST:
      return {
        ...state,
        isGettingCustomers: action.isGettingCustomers
      };
    case GET_CUSTOMERS_SUCCESS:
      return {
        ...state,
        isGettingCustomers: action.isGettingCustomers,
        customers: action.customers,
        customersCount: action.customersCount
      };
    case GET_CUSTOMERS_FAILURE:
      return {
        ...state,
        isGettingCustomers: action.isGettingCustomers,
        customers: [],
        customersCount: 0
      };
    case GET_CUSTOMER_DETAILS_REQUEST:
      // eslint-disable-next-line no-case-declarations
      const requestCustomers = state.customers.filter((c, i) => c.id === action.customerId && i === action.rowId);

      if (requestCustomers && requestCustomers.length === 1) {
        requestCustomers[0].isLoadingDetails = true;
      }

      return {
        ...state,
        getCustomerDetailsError: null,
        customers: state.customers.concat([])
      };
    case GET_CUSTOMER_DETAILS_SUCCESS:
      // eslint-disable-next-line no-case-declarations
      const matchedCustomers = state.customers.filter((c, i) => c.id === action.customerId && i === action.rowId);

      if (matchedCustomers && matchedCustomers.length === 1) {
        matchedCustomers[0].additionalData = action.customerDetails;
        matchedCustomers[0].isLoadingDetails = false;
      }

      return {
        ...state,
        getCustomerDetailsError: null,
        customers: state.customers.concat([])
      };
    case GET_CUSTOMER_DETAILS_FAILURE:
      // eslint-disable-next-line no-case-declarations
      const failureCustomers = state.customers.filter((c, i) => c.id === action.customerId && i === action.rowId);

      if (failureCustomers && failureCustomers.length === 1) {
        failureCustomers[0].additionalData = null;
        failureCustomers[0].isLoadingDetails = false;
      }

      return {
        ...state,
        getCustomerDetailsError: action.getCustomerDetailsError,
        customers: state.customers.concat([])
      };
    case GET_CUSTOMER_DETAILS_CLEAR:
      // eslint-disable-next-line no-case-declarations
      const clearCustomers = state.customers.filter((c, i) => c.id === action.customerId && i === action.rowId);

      if (clearCustomers && clearCustomers.length === 1) {
        clearCustomers[0].additionalData = null;
        clearCustomers[0].isLoadingDetails = false;
      }

      return {
        ...state,
        getCustomerDetailsError: null,
        customers: state.customers.concat([])
      };
    default:
      return state;
  }
}

export default customer;
